import { render, staticRenderFns } from "./IconTypeformWelcomeScreen.vue?vue&type=template&id=b55c1b24&"
import script from "./IconTypeformWelcomeScreen.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformWelcomeScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports